import React, { useEffect, useRef, useState, useCallback } from "react";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import Icon from "@mdi/react";
import { mdiAccountStar } from "@mdi/js";
import { PROJECT_PANEL } from "../../../utils/constants";
import { getCategoryData } from "../../../services/layout/layout";
import { useSelector } from "react-redux";
import handleError from "../../../utils/handleError";
import CategoriesSkeleton from "../../../components/Skeletons/CategoriesSkeleton";
import {
  getCities,
  saveClientData,
  checkNameAvailability,
  deleteCustomRecruit,
} from "../../../services/admin/client/client";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
import _, { set } from "lodash";
import { getClientDetails } from "../../../services/admin/client/client";
import { useParams } from "react-router-dom";
import { decrypt } from "../../../utils/commonLogics";
import { Toast } from "primereact/toast";
import { InputNumber } from "primereact/inputnumber";

const CreateClient = () => {
  const { id } = useParams();
  const editID = id;
  const fileInputRef = useRef(null);
  const uploadImageRef = useRef(null);
  const suggestionRef = useRef(null);
  const toast = useRef(null);
  const [error, setError] = useState("");
  const [client_image_error, setClientImageError] = useState("");
  const [client_name_error, setClientNameError] = useState("");
  const [client_city_error, setClientCityError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { panel_projects, token, user } = useSelector((state) => state.auth);
  const [categoryData, setCategoryData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState("");
  const [categoryInputs, setCategoryInputs] = useState({});
  const [showCitySuggestions, setShowCitySuggestions] = useState(false);
  const [customRecruitErrors, setCustomRecruitErrors] = useState({});
  const [selectePanelProject, setSelectedPanelProject] = useState(
    PROJECT_PANEL.SMART_PANEL,
  );
  const noOfParticipant = [
    { name: "100", code: "100" },
    { name: "200", code: "200" },
    { name: "300", code: "300" },
    { name: "400", code: "400" },
    { name: "500", code: "500" },
    { name: "600", code: "600" },
    { name: "700", code: "700" },
    { name: "800", code: "800" },
    { name: "900", code: "900" },
    { name: "1000", code: "1000" },
    { name: "1500", code: "1500" },
    { name: "2000", code: "2000" },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const showError = (message) => {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: message,
      life: 3000,
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionRef.current &&
        !suggestionRef.current.contains(event.target)
      ) {
        setShowCitySuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (id) {
      const formData = new FormData();
      formData.append("id", user.id);
      formData.append("type", user.type);
      formData.append("client_id", decrypt(id));
      getClientDetails(token, formData)
        .then((response) => {
          if (response?.data?.client_data) {
            const client = response?.data?.client_data;
            setClientData(client);
            setFormData({
              client_name: client.client_name || "",
              city_id: client.city_id || "",
              city_label: client.city_name || "",
              client_image: null,
              category_id: client.category_ids || "",
              imageSrc: client.image_url,
            });
            if (client.custom_recruits && client.custom_recruits.length > 0) {
              setCustomRecruits(groupByCategory(client.custom_recruits));
            }

            const selectedCategories = client.category_ids
              ? client.category_ids
                  .split(",")
                  .filter((id) => id && id.trim() !== "")
              : [];

            setCategoryInputs((prev) => {
              const newState = { ...prev };
              selectedCategories.forEach((catId) => {
                if (!newState[catId]) {
                  newState[catId] = {
                    recruit: "",
                    number: "",
                    show: true,
                    enable_syndicated:
                      client.category_enabled_syndicated?.find(
                        (data) => parseInt(data.category) === parseInt(catId),
                      )?.enable_syndicated === 1
                        ? true
                        : false,
                  };
                }
              });
              return newState;
            });
          } else {
            setClientData([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, navigate, dispatch);
        });
    } else {
      setLoading(false);
    }
  }, [id, token, user.id, user.type, navigate, dispatch]);

  const getCategoryPanelProjectData = () => {
    let reqBody = {
      id: parseInt(user.id),
      study_id:
        selectePanelProject === PROJECT_PANEL.SMART_PANEL
          ? parseInt(panel_projects.smart_panel)
          : parseInt(panel_projects.test_panel),
    };

    if (user?.type === "admin_user") {
      reqBody.client_id = user?.client_id;
    }

    getCategoryData(reqBody, token)
      .then((response) => {
        if (response?.data?.category_data) {
          setCategoryData(response.data.category_data);
        } else {
          console.error("No category data available.");
        }
      })
      .catch((error) => {
        handleError(error, navigate, dispatch);
      });
  };

  const getCitySuggestionsForClient = (city) => {
    const cityBody = new FormData();
    cityBody.append("term", city);
    getCities(token, cityBody)
      .then((response) => {
        if (response?.data) {
          setShowCitySuggestions(true);
          setCityData(response.data);
        } else {
          console.error("city data not found");
        }
      })
      .catch((error) => {
        handleError(error, navigate, dispatch);
      });
  };

  useEffect(() => {
    getCategoryPanelProjectData();
  }, []);

  const [formData, setFormData] = useState({
    client_name: "",
    city_id: "",
    city_label: "",
    client_image: null,
    category_id: "",
    imageSrc: null,
  });

  const [customRecruits, setCustomRecruits] = useState({});

  // Initialize with one default row when category becomes visible
  useEffect(() => {
    categoryData.forEach((category) => {
      if (categoryInputs[category.id]?.show && !customRecruits[category.id]) {
        addCustomRecruitRow(category.id, true);
      }
    });
  }, [categoryInputs, categoryData]);

  const handleImageClick = () => {
    if (!isSubmitting) {
      fileInputRef.current.click();
    }
  };

  const capitalizeFirstChar = (text) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const debouncedCheckNameAvailability = useCallback(
    _.debounce((name) => {
      const reqBody = new FormData();
      reqBody.append("name", name);
      if (editID) {
        reqBody.append("client_id", decrypt(editID));
      }

      checkNameAvailability(token, reqBody)
        .then((response) => {
          const inputElement = document.getElementById("client_name");
          if (response?.data?.success === 0 && response?.data?.exists) {
            setClientNameError("A client with this name already exists.");
            if (inputElement) inputElement.style.background = "#f8d7da";
          } else {
            setClientNameError("");
            if (inputElement) inputElement.style.background = "";
          }
        })
        .catch((error) => {
          handleError(error, navigate, dispatch);
        });
    }, 500),
    [token, navigate, dispatch],
  );

  const handleChange = (e, type = "input") => {
    if (isSubmitting) return;

    if (type === "file") {
      const file = e.target.files[0];
      if (!file) {
        setFormData((prev) => ({
          ...prev,
          imageSrc: "",
          client_image: null,
        }));
        setError("");
        setClientImageError("Image upload is mandatory.");
        return;
      }

      if (file.size > 300 * 1024) {
        setFormData((prev) => ({
          ...prev,
          imageSrc: "",
          client_image: null,
        }));
        setError("Image size must be 300KB or less.");
        setClientImageError("Image size must be 300KB or less.");
        return;
      }

      const objectUrl = URL.createObjectURL(file);
      const img = new Image();
      img.src = objectUrl;

      img.onload = () => {
        if (img.width >= 250 && img.height >= 250) {
          setFormData((prev) => ({
            ...prev,
            client_image: file,
            imageSrc: objectUrl,
          }));
          setError("");
          setClientImageError("");
        } else {
          URL.revokeObjectURL(objectUrl);
          setFormData((prev) => ({
            ...prev,
            imageSrc: "",
            client_image: null,
          }));
          setError("Minimum image dimensions: 250 × 250 pixels.");
          setClientImageError("Minimum image dimensions: 250 × 250 pixels.");
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        setFormData((prev) => ({
          ...prev,
          imageSrc: "",
          client_image: null,
        }));
        setError("Invalid image file.");
        setClientImageError("Invalid image file.");
      };
    } else if (type === "checkbox") {
      const id = e.value.toString();
      setFormData((prev) => {
        const current = prev.category_id ? prev.category_id.split(",") : [];
        const updated = current.includes(id)
          ? current.filter((catId) => catId !== id)
          : [...current, id];
        return { ...prev, category_id: updated.join(",") };
      });
      setCategoryInputs((prev) => {
        const newState = {
          ...prev,
          [id]: !prev[id]
            ? { recruit: "", number: "", show: true, enable_syndicated: false }
            : undefined,
        };

        // Add default row if this category is being shown and doesn't have recruits yet
        if (!prev[id] && !customRecruits[id]) {
          addCustomRecruitRow(id, true);
        }

        return newState;
      });
    } else {
      const { id, value } = e.target;
      const trimmedValue = value.trim();

      setFormData((prev) => ({
        ...prev,
        ...(id === "client_city"
          ? { city_id: "", city_label: value }
          : { [id]: value }),
      }));

      if (!trimmedValue) {
        const errorText = `${capitalizeFirstChar(id.replace("_", " "))} cannot be empty.`;

        if (id === "client_name") {
          setClientNameError(errorText);
          const inputElement = document.getElementById(id);
          if (inputElement) inputElement.style.background = "";
        } else if (id === "client_city") {
          setClientCityError(errorText);
        }

        setShowCitySuggestions(false);
        return;
      } else {
        if (id === "client_name") {
          setClientNameError("");
          const inputElement = document.getElementById(id);
          if (inputElement) inputElement.style.background = "";
        }
        if (id === "client_city") {
          setClientCityError("");
        }
      }

      if (id === "client_name") {
        debouncedCheckNameAvailability(trimmedValue);
      }

      if (id === "client_city" && trimmedValue.length) {
        if (window.citySuggestionDebounceTimeout) {
          clearTimeout(window.citySuggestionDebounceTimeout);
        }

        window.citySuggestionDebounceTimeout = setTimeout(() => {
          getCitySuggestionsForClient(trimmedValue);
        }, 500);
      }
    }
  };

  const getCommaSeparatedCategories = () => {
    return formData.category_id
      .split(",")
      .filter((id) => id !== undefined && id !== null && id !== "")
      .map(String)
      .join(",");
  };

  const getSyndicatedValues = () => {
    return formData.category_id
      .split(",")
      .filter((id) => id !== undefined && id !== null && id !== "")
      .map((categoryId) =>
        categoryInputs[categoryId]?.enable_syndicated ? 1 : 0,
      )
      .join(",");
  };

  const validateCustomRecruits = () => {
    const errors = {};
    let hasError = false;
    let firstErrorElement = null;

    // Get selected categories
    const selectedCategories = formData.category_id
      .split(",")
      .filter((id) => id && id.trim() !== "");

    selectedCategories.forEach((categoryId) => {
      const recruits = customRecruits[categoryId] || [];

      if (recruits.length > 0) {
        errors[categoryId] = [];

        recruits.forEach((recruit, index) => {
          const recruitError = {};

          if (!recruit.recruit || recruit.recruit.trim() === "") {
            recruitError.recruit = true;
            hasError = true;
          }

          if (!recruit.number || recruit.number === "") {
            recruitError.number = true;
            hasError = true;
          }

          if (
            !recruit.xmot_credits ||
            recruit.xmot_credits < 100 ||
            recruit.xmot_credits > 9999999999
          ) {
            recruitError.xmot_credits = true;
            hasError = true;
          }

          errors[categoryId][index] = recruitError;

          // Set first error element for scrolling
          if (
            !firstErrorElement &&
            (recruitError.recruit ||
              recruitError.number ||
              recruitError.xmot_credits)
          ) {
            firstErrorElement = { categoryId, index };
          }
        });
      }
    });

    setCustomRecruitErrors(errors);
    return { hasError, firstErrorElement };
  };

  // const handleSaveClient = async () => {
  //   if (isSubmitting) return;
  //   setIsSubmitting(true);
  //   let firstErrorField = null;

  //   if (error) {
  //     if (uploadImageRef.current) {
  //       uploadImageRef.current.scrollIntoView({
  //         behavior: "smooth",
  //         block: "center",
  //       });
  //     }
  //     return;
  //   }

  //   if (!formData.client_name.trim()) {
  //     setClientNameError("Please enter a client name.");
  //     firstErrorField = firstErrorField || "client_name";
  //     setIsSubmitting(false);
  //   } else if (client_name_error) {
  //     firstErrorField = firstErrorField || "client_name";
  //   } else {
  //     setClientNameError("");
  //   }

  //   if (!formData.city_label.trim()) {
  //     setClientCityError("Please enter the client's city.");
  //     firstErrorField = firstErrorField || "client_city";
  //     setIsSubmitting(false);
  //   } else {
  //     setClientCityError("");
  //   }

  //   if (firstErrorField) {
  //     const element = document.getElementById(firstErrorField);
  //     if (element) {
  //       element.scrollIntoView({ behavior: "smooth", block: "center" });
  //       element.focus();
  //       if (firstErrorField === "client_name") {
  //         if (client_name_error) {
  //           element.style.background = "#f8d7da";
  //         } else {
  //           element.style.background = "";
  //         }
  //       } else {
  //         element.style.background = "";
  //       }
  //     }
  //     return;
  //   }

  //   // Validate custom recruits
  //   const { hasError, firstErrorElement } = validateCustomRecruits();

  //   if (hasError) {
  //     showError("Please fill in all custom recruit fields.");

  //     // Scroll to the first error
  //     if (firstErrorElement) {
  //       setTimeout(() => {
  //         const errorElement = document.getElementById(
  //           `recruit-${firstErrorElement.categoryId}-${firstErrorElement.index}`
  //         );
  //         if (errorElement) {
  //           errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
  //         }
  //       }, 100);
  //     }
  //     setIsSubmitting(false);
  //     return;
  //   }

  //   const selectedCategoryIds = getCommaSeparatedCategories();
  //   const multipartData = new FormData();
  //   multipartData.append("client_name", formData.client_name || "");
  //   multipartData.append("client_city", formData.city_label || "");
  //   multipartData.append("city_id", formData.city_id || "");
  //   multipartData.append("category_id", selectedCategoryIds);
  //   multipartData.append("action_type", id ? "edit" : "add");
  //   if (formData.client_image instanceof File) {
  //     multipartData.append("client_image", formData.client_image);
  //   }

  //   const categoryEnabledSyndicated = getSyndicatedValues();
  //   multipartData.append("category_enabled_syndicated", categoryEnabledSyndicated);

  //   // Add custom recruits data
  //   Object.entries(customRecruits).forEach(([categoryId, recruits]) => {
  //     recruits.forEach((recruit) => {
  //       const dataToSend = {
  //         category_id: parseInt(categoryId),
  //         recruit: recruit.recruit,
  //         number: recruit.number,
  //         isDefault: recruit.isDefault,
  //         xmot_credits: recruit?.xmot_credits
  //       };
  //       if (recruit.id) {
  //         dataToSend.id = recruit.id;
  //       } else {
  //         dataToSend.id = 0;
  //       }
  //       multipartData.append(`custom_recruits[]`, JSON.stringify(dataToSend));
  //     });
  //   });

  //   if (id) {
  //     multipartData.append("client_id", decrypt(id));
  //   }

  //   saveClientData(token, multipartData)
  //     .then((response) => {
  //       if (response?.data?.success === 1) {
  //         navigate("/admin-panel/clients");
  //       } else {
  //         console.error("Saving client data was unsuccessful.");
  //         setIsSubmitting(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setIsSubmitting(false);
  //       if (error?.response?.data?.message !== "Invalid Token") {
  //         showError(error?.response?.data?.message);
  //       } else {
  //         handleError(error, navigate, dispatch);
  //       }
  //     });
  // };

  const handleSaveClient = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    let firstErrorField = null;

    if (error) {
      if (uploadImageRef.current) {
        uploadImageRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    if (!formData.client_name.trim()) {
      setClientNameError("Please enter a client name.");
      firstErrorField = firstErrorField || "client_name";
      setIsSubmitting(false);
    } else if (client_name_error) {
      firstErrorField = firstErrorField || "client_name";
    } else {
      setClientNameError("");
    }

    if (!formData.city_label.trim()) {
      setClientCityError("Please enter the client's city.");
      firstErrorField = firstErrorField || "client_city";
      setIsSubmitting(false);
    } else {
      setClientCityError("");
    }

    if (firstErrorField) {
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
        if (firstErrorField === "client_name") {
          if (client_name_error) {
            element.style.background = "#f8d7da";
          } else {
            element.style.background = "";
          }
        } else {
          element.style.background = "";
        }
      }
      return;
    }

    // Validate custom recruits
    const { hasError, firstErrorElement } = validateCustomRecruits();

    if (hasError) {
      showError(
        "Please fill in all custom recruit fields correctly. XMOT Credits must be between 100 and 9,999,999,999.",
      );

      if (firstErrorElement) {
        setTimeout(() => {
          const errorElement = document.getElementById(
            `recruit-${firstErrorElement.categoryId}-${firstErrorElement.index}`,
          );
          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 100);
      }
      setIsSubmitting(false);
      return;
    }

    const selectedCategoryIds = getCommaSeparatedCategories();
    const selectedCategoryIdsArray = selectedCategoryIds
      .split(",")
      .map((id) => parseInt(id));

    const multipartData = new FormData();
    multipartData.append("client_name", formData.client_name || "");
    multipartData.append("client_city", formData.city_label || "");
    multipartData.append("city_id", formData.city_id || "");
    multipartData.append("category_id", selectedCategoryIds);
    multipartData.append("action_type", id ? "edit" : "add");
    if (formData.client_image instanceof File) {
      multipartData.append("client_image", formData.client_image);
    }

    const categoryEnabledSyndicated = getSyndicatedValues();
    multipartData.append(
      "category_enabled_syndicated",
      categoryEnabledSyndicated,
    );

    // Add custom recruits data - ONLY for selected categories
    Object.entries(customRecruits).forEach(([categoryId, recruits]) => {
      const catId = parseInt(categoryId);

      // Only include recruits for selected categories
      if (selectedCategoryIdsArray.includes(catId)) {
        recruits.forEach((recruit) => {
          const dataToSend = {
            category_id: catId,
            recruit: recruit.recruit,
            number: recruit.number,
            isDefault: recruit.isDefault,
            xmot_credits: recruit?.xmot_credits,
          };
          if (recruit.id) {
            dataToSend.id = recruit.id;
          } else {
            dataToSend.id = 0;
          }
          multipartData.append(`custom_recruits[]`, JSON.stringify(dataToSend));
        });
      }
    });

    if (id) {
      multipartData.append("client_id", decrypt(id));
    }

    saveClientData(token, multipartData)
      .then((response) => {
        if (response?.data?.success === 1) {
          navigate("/admin-panel/clients");
        } else {
          console.error("Saving client data was unsuccessful.");
          setIsSubmitting(false);
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        if (error?.response?.data?.message !== "Invalid Token") {
          showError(error?.response?.data?.message);
        } else {
          handleError(error, navigate, dispatch);
        }
      });
  };
  const addCustomRecruitRow = (categoryId, isDefault = false) => {
    setCustomRecruits((prev) => {
      const currentRecruits = prev[categoryId] || [];
      return {
        ...prev,
        [categoryId]: [
          ...currentRecruits,
          { recruit: "", number: "", xmot_credits: 1000, isDefault },
        ],
      };
    });
  };

  const updateCustomRecruit = (categoryId, index, field, value) => {
    setCustomRecruits((prev) => {
      const updatedRecruits = [...(prev[categoryId] || [])];
      updatedRecruits[index] = {
        ...updatedRecruits[index],
        [field]: value,
      };
      return {
        ...prev,
        [categoryId]: updatedRecruits,
      };
    });

    // Clear error for this field when user starts typing
    setCustomRecruitErrors((prev) => {
      const newErrors = { ...prev };
      if (newErrors[categoryId] && newErrors[categoryId][index]) {
        newErrors[categoryId][index] = {
          ...newErrors[categoryId][index],
          [field]: false,
        };
      }
      return newErrors;
    });
  };

  const groupByCategory = (recruits) => {
    const grouped = {};
    recruits.forEach((recruit) => {
      if (!grouped[recruit.category_id]) {
        grouped[recruit.category_id] = [];
      }
      grouped[recruit.category_id].push({
        id: recruit.id,
        recruit: recruit.recruit,
        number: recruit.number,
        isDefault: recruit.isDefault,
        xmot_credits: recruit.xmot_credits || 1000,
      });
    });
    return grouped;
  };

  const removeCustomRecruit = async (categoryId, index) => {
    setCustomRecruits((prev) => {
      const updatedRecruits = [...(prev[categoryId] || [])];
      const recruitToRemove = updatedRecruits[index];

      if (recruitToRemove && recruitToRemove.id) {
        (async () => {
          try {
            const formData = new FormData();
            formData.append("record_id", recruitToRemove.id);
            await deleteCustomRecruit(token, formData);
            setCustomRecruits((prevState) => {
              const newRecruits = [...(prevState[categoryId] || [])];
              newRecruits.splice(index, 1);
              return {
                ...prevState,
                [categoryId]: newRecruits,
              };
            });
            // Clear errors for this recruit
            setCustomRecruitErrors((prevErrors) => {
              const newErrors = { ...prevErrors };
              if (newErrors[categoryId]) {
                newErrors[categoryId].splice(index, 1);
              }
              return newErrors;
            });
          } catch (error) {
            console.error("Error deleting custom recruit:", error);
            showError("Failed to delete the custom recruit. Please try again.");
          }
        })();
        return prev;
      } else {
        updatedRecruits.splice(index, 1);
        // Clear errors for this recruit
        setCustomRecruitErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors[categoryId]) {
            newErrors[categoryId].splice(index, 1);
          }
          return newErrors;
        });
        return {
          ...prev,
          [categoryId]: updatedRecruits,
        };
      }
    });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="container-fluid page-wrapper"
      style={{ position: "relative" }}
    >
      <Toast ref={toast} />
      <div className={`row ${isSubmitting ? "pointer-events-none" : ""}`}>
        <div className="col-12 col-md-12">
          <div className="card shadow-card" style={{ minHeight: "590px" }}>
            <div className="d-flex justify-content-between align-items-center p-3">
              <h6 className="fw-bold m-0 title">
                {id ? "Edit client" : "Create a Client"}
              </h6>
            </div>
            <Divider style={{ margin: "0.5rem 0", padding: "0 1rem" }} />
            <div className="p-4">
              <div className="card shadow-card-2">
                <h6 className="card-title text-start fw-600">Client Info</h6>
                <div className="row mb-3">
                  <div className="col-md-4 border p-2 mx-3">
                    <div
                      ref={uploadImageRef}
                      className="d-flex align-items-center"
                      style={isSubmitting ? { opacity: 0.5 } : undefined}
                    >
                      <div
                        style={{
                          width: "55%",
                          height: "150px",
                          backgroundColor: "#eee",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {formData.imageSrc ? (
                          <img
                            src={formData.imageSrc}
                            alt="Uploaded"
                            style={{ maxWidth: "100%", maxHeight: "100%" }}
                          />
                        ) : (
                          <Icon
                            path={mdiAccountStar}
                            size={4}
                            color={"#9e9e9e"}
                            horizontal
                          />
                        )}
                      </div>
                      <div className="text-start ms-3">
                        <span
                          className="text-primary fw-600"
                          style={{
                            cursor: isSubmitting ? "not-allowed" : "pointer",
                          }}
                          onClick={isSubmitting ? undefined : handleImageClick}
                        >
                          Upload image
                        </span>
                        <input
                          type="file"
                          accept="image/*"
                          ref={fileInputRef}
                          onChange={(e) => handleChange(e, "file")}
                          style={{ display: "none" }}
                          id="client_image"
                          disabled={isSubmitting}
                        />
                        <div className="text-muted small">
                          Preferred size <br /> (250px * 250px)
                        </div>
                        {(error || client_image_error) && (
                          <div className="text-danger mt-2">
                            {error || client_image_error}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <Divider />
                <div className="row mt-4">
                  <div className="col-md-6 mb-2">
                    <label
                      htmlFor="client_name"
                      className="form-label float-start dark-text"
                    >
                      Client name:
                    </label>
                    <InputText
                      id="client_name"
                      className={`w-100 inputField`}
                      autoComplete="off"
                      value={formData.client_name}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    />
                    <div
                      className="text-danger mt-2 text-start"
                      id="client_name_error"
                    >
                      {client_name_error}
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <label
                      htmlFor="client_city"
                      className="form-label float-start dark-text"
                    >
                      City:
                    </label>
                    <InputText
                      id="client_city"
                      className={`w-100 inputField`}
                      autoComplete="off"
                      value={formData.city_label}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    />
                    <div
                      className="text-danger mt-2 text-start"
                      id="client_city_error"
                    >
                      {client_city_error}
                    </div>
                    {showCitySuggestions && (
                      <div
                        ref={suggestionRef}
                        className="position-relative"
                        style={{ width: "100%" }}
                      >
                        <ul
                          className="list-group position-absolute shadow"
                          style={{ zIndex: 10, width: "100%" }}
                        >
                          {cityData.length > 0 ? (
                            cityData.map((city) => (
                              <li
                                key={city.id}
                                className="list-group-item list-group-item-action text-start"
                                onClick={() => {
                                  setFormData((prev) => ({
                                    ...prev,
                                    city_id: city.id,
                                    city_label: city.label,
                                  }));
                                  setShowCitySuggestions(false);
                                }}
                              >
                                {city.label}
                              </li>
                            ))
                          ) : (
                            <li className="list-group-item list-group-item-action text-start">
                              No cities available.
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                <Divider />

                <h6 className="text-start mt-4 fw-600">Categories</h6>
                <p className="text-start fw-600 title fs-14">
                  Select subscribed categories for the client
                </p>

                {categoryData.length > 0 ? (
                  categoryData.map((category) => (
                    <div className="mb-4 text-start" key={category.id}>
                      <div className="row">
                        <div className="col-12 col-md-3 col-lg-3">
                          <Checkbox
                            inputId={`category${category.id}`}
                            value={category.id}
                            onChange={(e) => handleChange(e, "checkbox")}
                            checked={formData.category_id
                              .split(",")
                              .includes(category.id.toString())}
                            disabled={isSubmitting}
                          />
                          <label
                            htmlFor={`category${category.id}`}
                            className="ms-2"
                            title={category.category}
                            style={{
                              display: "inline-block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              verticalAlign: "bottom",
                              maxWidth: "90%",
                            }}
                          >
                            {category.category}
                          </label>
                        </div>
                        <div className="col-12 col-md-9 col-lg-9">
                          {categoryInputs[category.id]?.show && (
                            <div
                              className="d-flex align-items-start p-3 gap-3 align-items-stretch"
                              style={{
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                              }}
                            >
                              <div
                                className="syndicated-data pe-3"
                                style={{
                                  borderRight: "1px solid #ced4da",
                                }}
                              >
                                <div className="title mb-2">
                                  Syndicated Data
                                </div>

                                <div className="d-flex align-items-center">
                                  <Checkbox
                                    inputId={`enable-syndicated-${category.id}`}
                                    value={category.id}
                                    onChange={(e) => {
                                      const id = e.value.toString();
                                      setCategoryInputs((prev) => ({
                                        ...prev,
                                        [id]: {
                                          ...prev[id],
                                          enable_syndicated: e.checked,
                                        },
                                      }));
                                    }}
                                    checked={
                                      categoryInputs[category.id]
                                        ?.enable_syndicated
                                    }
                                    disabled={isSubmitting}
                                  />
                                  <label
                                    htmlFor={`enable-syndicated-${category.id}`}
                                    className="ms-2"
                                    title={"Enable Syndicated Data"}
                                    style={{
                                      display: "inline-block",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      verticalAlign: "bottom",
                                      maxWidth: "90%",
                                    }}
                                  >
                                    Enable Syndicated Data
                                  </label>
                                </div>
                              </div>
                              <div id="customRecruitCont" className="w-100">
                                {(customRecruits[category.id] || []).map(
                                  (recruit, index) => (
                                    <div
                                      key={index}
                                      id={`recruit-${category.id}-${index}`}
                                      className="mb-2"
                                    >
                                      <div className="row">
                                        <div className="col-sm-6">
                                          <label className="me-2">
                                            Custom Recruit {index + 1}:
                                          </label>
                                          <InputText
                                            value={recruit.recruit}
                                            onChange={(e) =>
                                              updateCustomRecruit(
                                                category.id,
                                                index,
                                                "recruit",
                                                e.target.value,
                                              )
                                            }
                                            className={`${customRecruitErrors[category.id]?.[index]?.recruit ? "error-border" : ""} me-2 inputField w-100`}
                                          />
                                        </div>
                                        <div className="col-sm-3">
                                          <label className="me-2">#:</label>
                                          <Dropdown
                                            value={recruit.number}
                                            onChange={(e) =>
                                              updateCustomRecruit(
                                                category.id,
                                                index,
                                                "number",
                                                e.value,
                                              )
                                            }
                                            options={noOfParticipant}
                                            optionLabel="name"
                                            placeholder="Select"
                                            className={`${customRecruitErrors[category.id]?.[index]?.number ? "error-border" : ""} inputField w-100`}
                                          />
                                        </div>
                                        <div className="col-sm-3">
                                          <label className="me-2">
                                            XMOT Credits:
                                          </label>
                                          <InputNumber
                                            className={`inputField`}
                                            min={100}
                                            max={9999999999}
                                            maxLength={10}
                                            value={recruit.xmot_credits}
                                            onValueChange={(e) =>
                                              updateCustomRecruit(
                                                category.id,
                                                index,
                                                "xmot_credits",
                                                e.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      {!recruit.isDefault && (
                                        <Button
                                          label="Remove"
                                          className="btn btn-link fw-400 fs-14 text-decoration-none text-danger"
                                          onClick={() =>
                                            removeCustomRecruit(
                                              category.id,
                                              index,
                                            )
                                          }
                                          style={{ padding: "0px 0px 6px 0px" }}
                                        />
                                      )}
                                    </div>
                                  ),
                                )}
                                <Button
                                  label="+ Add"
                                  className="btn btn-link fw-600 text-decoration-none"
                                  onClick={() =>
                                    addCustomRecruitRow(category.id)
                                  }
                                  style={{ padding: "0px" }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <CategoriesSkeleton />
                )}

                <div className="d-flex justify-content-center gap-2 mt-4 mb-5">
                  <Button
                    label="Cancel"
                    className="px-4 py-2 fw-bold cancel"
                    onClick={() => navigate("/admin-panel/clients")}
                    disabled={isSubmitting}
                  />
                  <Button
                    label={
                      <>
                        Save
                        {isSubmitting && (
                          <ProgressSpinner
                            style={{
                              width: "20px",
                              height: "20px",
                              marginLeft: "8px",
                            }}
                            strokeWidth="4"
                            fill="transparent"
                            animationDuration=".5s"
                          />
                        )}
                      </>
                    }
                    className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
                    onClick={() => handleSaveClient()}
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateClient;
